/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    CANCEL: 'Ακύρωση',
    CONFIRM: 'Επιβεβαίωση',
    SAVE: 'Αποθήκευση',
    SEARCH: 'Αναζήτηση'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'Ημερομηνία λήξης',
    MEMBER_ID: 'Αναγνωριστικό μέλους',
    NAME: 'Όνομα'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Προσθήκη μελών',
    CREATE_MEMBER: 'Προσθήκη μέλους',
    DELETE_MEMBER_MODAL_TITLE: 'Διαγραφή μέλους',
    EDIT_MEMBER: 'Επεξεργασία μέλους',
    EMAIL: 'E-mail',
    END_DATE: 'Ημερομηνία λήξης',
    MEMBERS: 'Συνεργάτες',
    NAME: 'Όνομα',
    NO: 'Όχι',
    YES: 'Ναι'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Είστε σίγουροι ότι θέλετε να αποκλείσετε τον εταίρο;',
    NO_MEMBER_NAME_EMAIL: 'Χωρίς όνομα ή/και e-mail',
    NO_MEMBER_NAME_EMAIL_DETAIL:
      'Εισάγετε το όνομά σας ή/και τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας',
    NO_ROWS_MEMBERS: 'Δεν υπάρχουν εταίροι',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Αλλαγή των κριτηρίων αναζήτησης'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Συνεργάτης που εξαλείφθηκε επιτυχώς',
    MEMBER_DETAILS_SAVED: 'Το μέλος αποθηκεύτηκε επιτυχώς',
    SUCCESS: 'Επιτυχία'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Επεξεργασία μέλους',
    EMAIL: 'E-mail',
    END_DATE: 'Ημερομηνία λήξης',
    MEMBER_ID: 'Αναγνωριστικό μέλους',
    NAME: 'Όνομα',
    REMOVE_MEMBER: 'Διαγραφή μέλους'
  }
};
